var map = {
	"./1.png": 54208,
	"./2.png": 70354,
	"./3.png": 38815,
	"./4.png": 42722,
	"./5.png": 34290,
	"./6.png": 8109,
	"./7.png": 7976,
	"./8.png": 42932,
	"./9.png": 39757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78118;